import React, { FC, useState } from "react";

// i18n
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

// services
import { IPaymentMethodProvider } from "@modules/PaymentProcessing/services/paymentMethods";

// hooks
import { IOutlets } from "@Libs/Transclusion/types/outlets";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { PayWithCreditCard as StripePayWithCreditCard } from "./Adapters/Stripe/PayWithCreditCard";

type Props = Omit<
  IOutlets["configure-payment.body"]["props"],
  "paymentMethod" | "basket"
> & { isAllowedPaymentMethodSingle?: boolean; children?: React.ReactNode };


const PROVIDER_ADAPTERS = {
  stripe: StripePayWithCreditCard,
};

export const PayWithCreditCard: FC<Props> = ({
  onSubmit,
  onBack,
  onSetupError,
  isAllowedPaymentMethodSingle,
  children,
}) => {
  const [isServerError, setIsServerError] = useState(false);

  const handleSubmit = async (
    provider: IPaymentMethodProvider<PaymentMethodType.CREDIT_CARD>
  ) => {
    await onSubmit?.<PaymentMethodType.CREDIT_CARD>(
      {
        provider,
        paymentMethod: PaymentMethodType.CREDIT_CARD,
        isPaymentConfirmed: true,
      },
      {
        onError: async () => setIsServerError(true),
      }
    );
  };

  const Adapter = PROVIDER_ADAPTERS["stripe"];

  return (
    <PaymentMethodForm>
      {isServerError && <PaymentMethodForm.Error onClick={onBack} />}
      <PaymentMethodForm.Header
        onChangeClick={onBack}
        paymentMethod={PaymentMethodType.CREDIT_CARD}
        isAllowedPaymentMethodSingle={isAllowedPaymentMethodSingle}
      >
        <FormattedMessage {...messages.creditCard} />
      </PaymentMethodForm.Header>
      <PaymentMethodForm.Body>
        <Adapter
          onSubmit={handleSubmit}
          setIsServerError={setIsServerError}
          onSetupError={onSetupError}
        >
          {children}
        </Adapter>
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
